import styled from 'styled-components';
import { colors, fontFamily } from 'components/styles/_variables';
import { respondTo } from '../../styles/_respondTo';

export const StyledMessageButton = styled.button`
  position: fixed;
  top: 20px;
  right: 23px;
  z-index: 3;
  background-color: white;
  padding: 10px 12px;
  border-radius: 8px;
  border: solid 1px #ff7828;
  color: #ff7828;
  font-family: ${fontFamily.primary};
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.71;
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: 0.3s ease all;
  width: 155px;

  :hover {
    color: #ff7828;
  }

  ${respondTo.mobile`
    position: relative;
    padding: 0;
    top: 0;
    border: none;
    right: 0;
    font-size: 14px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.71;
    letter-spacing: normal;
  `}
`;

export const StyledIcon = styled.span`
  width: 17px;
  height: 16px;
  margin-left: 20px;
`;

export const StyledContentWrapper = styled.div`
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  position: fixed;
  z-index: 999;
  background-color: white;
  padding: 0 40px;
  display: flex;
  justify-content: center;
  ${respondTo.mobile`
    // padding: 20px;
    padding: 0;
  `}
`;

export const ContentHeader = styled.div`
  padding-top: 40px;
  margin-bottom: -1px;
  z-index: 2;
  //flex: 1;
  ${respondTo.mobile`
      padding-top: 15px;
  `}
`;

export const ContentBody = styled.div`
  flex: 1;
  z-index: 1;
  overflow-y: auto;
  padding: 0 20px 0 30px;

  ${respondTo.mobile`
    padding: 0 14px 120px 20px;  
  `}
`;

export const StyledContent = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 760px;
  max-width: 760px;
  ${respondTo.mobile`
    min-width: 100%;
    max-width: 100%;
  `}
`;

export const ContentTitle = styled.h2`
  font-family: ${fontFamily.primary};
  font-size: 24px;
  font-weight: bold;
  color: #636262;
`;

export const CloseIcon = styled.span`
  //padding: 0 0 0 20px;
  //width: 20px;
  //height: 20px;
  cursor: pointer;

  ${respondTo.mobile`
    width: 14px;
  height: 14px;
  `}
`;

export const ContentRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 30px;

  ${respondTo.mobile`
    padding: ${({ mobilePadding = '20px' }) => mobilePadding};
  `}
`;

export const SearchInputWrapper = styled.div`
  width: 620px;
  position: relative;
`;

export const SearchInputIcon = styled.span`
  position: absolute;
  left: 13px;
  top: 0;
  bottom: 0;
  margin: auto;
  width: 17px;
  height: 17px;
`;

export const SearchInput = styled.input`
  border-radius: 6px;
  border: solid 0.5px
    ${({ failed }) => (failed ? colors.theme.danger : colors.elements.primary)};
  padding: 9px 13px 9px 44px;
  font-family: ${fontFamily.primary};
  font-size: 14px;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: -0.05px;
  color: #636262;
  width: 100%;
  ${respondTo.mobile`
      width: 100%;
  `}
  &::-webkit-input-placeholder {
    /* Edge */
    opacity: 0.6;
  }

  &:-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    opacity: 0.6;
  }

  &::placeholder {
    opacity: 0.6;
  }

  &:disabled {
    cursor: not-allowed;
  }
  -moz-appearance: textfield;
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;

export const Title = styled.h5`
  margin: 0;
  padding: 0;
  font-family: ${fontFamily.primary};
  font-size: 16px;
  font-weight: 600;
  color: #636262;
`;

export const MessageRow = styled.div`
  //padding: 0 20px 0 0;

  ${respondTo.mobile`
    padding: 0;
  `}
`;

export const MessageDate = styled(Title)`
  margin: 20px 0 0 0;
  color: #ff7828;
  text-transform: capitalize;
`;

export const Description = styled(Title)`
  font-size: 14px;
  color: #636262;
  white-space: break-spaces;
  font-weight: normal;
  margin-top: 10px;
`;

export const ShowButton = styled.span`
  padding: 3px 7px;
  border-radius: 8px;
  background-color: #ff7828;
  font-size: 10px;
  font-weight: bold;
  color: white;
  text-align: center;
  cursor: pointer;
`;
